module.exports = __webpack_public_path__ + "static/media/filter_alt_off.1fdcc0f2.svg";